import { Button as HeadlessUiButton } from "@headlessui/react"
import haptics from "@helpers/haptics"
import { ArrowRightIcon } from "@heroicons/react/24/solid"
import { twMerge } from "tailwind-merge"

interface Props {
  className?: string
  disabled?: boolean
  onClick?: () => void
  title: string
  type?: "button" | "submit" | "reset"
  arrow?: boolean
}

export default function Button({
  className = "",
  disabled = false,
  onClick,
  title,
  type = "button",
  arrow = false,
}: Props) {
  return (
    <HeadlessUiButton
      className={twMerge(
        "theme-button-primary flex items-center justify-center gap-2",
        className,
      )}
      disabled={disabled}
      onClick={() => {
        haptics.trigger("light")
        onClick?.()
      }}
      type={type}
    >
      {title}
      {arrow && <ArrowRightIcon className="h-6 w-6 shrink-0" />}
    </HeadlessUiButton>
  )
}
